import { useMemo } from "react";
import { INTAKE_FORM_SECTIONS_MAPPER } from "@/pages/app/provider/scheduling/appointment";
import { usePatientIntakeFormList } from "@/queries/patient-portal/forms/use-patient-intake-form-list";
import { DEF_PAGINATION, getXtenantId } from "@/utils/utils";
import { CUSTOM_FORMS_SEPARATOR } from "../group-appointment-constant";
import {
  PatientFormItem,
  SubmittedIntakeForm,
} from "../group-appointment-types";

export type UsePatientForms = {
  forms: PatientFormItem[];
  submittedForm?: SubmittedIntakeForm;
  isLoading: boolean;
  isError: boolean;
};

/** One patient's chosen forms, flagged when submitted, plus the record their preview reads. */
export const usePatientForms = (
  appointmentId: string,
  customForms: string | null
): UsePatientForms => {
  const { data, isLoading, isError } = usePatientIntakeFormList({
    appointmentUuid: appointmentId,
    pagination: DEF_PAGINATION,
    xTENANTID: getXtenantId(),
  });

  const submittedForm: SubmittedIntakeForm | undefined =
    data?.data?.content?.[0];

  const forms = useMemo(() => {
    const submittedNames =
      submittedForm?.formName?.split(CUSTOM_FORMS_SEPARATOR) ?? [];

    return (customForms?.split(CUSTOM_FORMS_SEPARATOR) ?? []).map((name) => ({
      name,
      label: INTAKE_FORM_SECTIONS_MAPPER[name] ?? name,
      isSubmitted: submittedNames.includes(name),
    }));
  }, [customForms, submittedForm]);

  return { forms, submittedForm, isLoading, isError };
};
